module.exports = __webpack_public_path__ + "static/img/tian-guan-jin.48d92c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tian-guan-jin.jpg
// module id = 0gjl
// module chunks = 1